import React, { Component } from 'react';
import Collapse from 'react-bootstrap/lib/Collapse';

class CollapsablePanel extends Component {
    constructor(props, context) {
        super(props, context);
    
        this.state = {
          collapsed: {}
        };
      }

    getCollapseState(location){
        return this.state.collapsed[location] || {}
    }

    setCollapseState(location, key){
        let newState = {
            collapsed: {
                [location]: {
                    ...this.getCollapseState(location),
                    [key]: !this.getCollapseState(location)[key]
                }
            }
        };
        
        this.setState(newState);
    }
    
    render(){
        const { location, section, title, className, children } = this.props;
        const open = !!this.getCollapseState(location)[section];
        const bodyId = ('ib-collapsible-' + (location || '') + '-' + section).replace(/[^A-Za-z0-9_-]/g, '-');
        return (<div className={'ib-collapsible' + (open ? ' is-open' : '') + (className ? ' ' + className : '')}>
            <button type="button" className="ib-collapsible-header" aria-expanded={open} aria-controls={bodyId} onClick={() => this.setCollapseState(location, section)}>
                <span className="ib-collapsible-title">{title}</span>
                <span className="ib-collapsible-chevron" aria-hidden="true"></span>
            </button>
            <Collapse in={open}>
                <div id={bodyId}>
                    <div className="collapse-panel ib-collapsible-body" data-section={section}>
                        {children}
                    </div>
                </div>
            </Collapse>
        </div>);
    }
}

export default CollapsablePanel;



// WEBPACK FOOTER //
// app/containers/CollapsePanel.jsx